import React, {Component, ErrorInfo, FunctionComponent, useEffect, Fragment} from 'react';
import { useParams } from 'react-router';
import { useQuery } from '@apollo/react-hooks';
import { GET_POST_QUERY } from '../../graphql/queries';
import Layout from '../../containers/layout';
import { timestampToPostDate } from '../../helpers/date';

interface IPostData {
  author: {
    firstName: string;
    lastName: string;
  },
  content: string;
  title: string;
  createdAt: number;
}

const Post: FunctionComponent = () => {
  const params = useParams<{ slug: string }>();
  const { data, loading } = useQuery<{ postBySlug: IPostData }>(GET_POST_QUERY, { variables: { slug: params.slug }});
  const post = data?.postBySlug;

  return (
    <Layout showImageHeader={false}>
      <div className="w-3/4 flex flex-col justify-center mx-auto text-center pb-16">
        {post && (
          <Fragment>
            <div className="mt-24 py-40">
              <h1 className="font-poppins text-4xl font-bold">{post.title}</h1>
              <div>
            <span className="uppercase font-bold text-xs font-poppins">
              {timestampToPostDate(post.createdAt)} | BY {post.author.firstName} {post.author.lastName}
            </span>
              </div>
            </div>
            <div className="post-content text-left" dangerouslySetInnerHTML={{ __html: post.content }} />
          </Fragment>
        )}
        {loading && <span className="mt-24 py-40 spinner" />}
      </div>
    </Layout>
  )
};

export default Post;
